import React from "react";
import { useLocation } from "react-router-dom";
import { Flex, Tab, Tabs } from "@jsq/ds/core";
import { RiskLegend } from "../RiskLegend";
import * as styles from "./styles_vanilla.css";
import { TabConfig } from "./types";

type TabSectionProps = {
  tabs: TabConfig[];
  showManagerTabs?: boolean;
};

export const TabSection: React.FC<TabSectionProps> = ({ tabs, showManagerTabs }) => {
  const location = useLocation();

  const checkIsTabActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const visibleTabs = tabs.filter((tab) => tab.visible);

  if (visibleTabs.length <= 1) {
    return null;
  }
  const activeTab = visibleTabs.find((tab) => checkIsTabActive(tab.path));

  const showLegend =
    showManagerTabs && (activeTab?.key === "clients" || activeTab?.key === "individuals");

  return (
    <Flex
      className={styles.tabsContainer}
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Tabs hasBottomBorder={false} tabsListClassName={styles.tabsList}>
        {visibleTabs.map((tab) => (
          <Tab
            key={tab.key}
            text={tab.label}
            active={tab.key === activeTab?.key}
            to={tab.path}
            data-testid={tab.testId}
            className={tab.key === activeTab?.key ? styles.tabActive : styles.tabInactive}
          />
        ))}
      </Tabs>
      {showLegend && <RiskLegend />}
    </Flex>
  );
};
